import i18n from '@cashew/i18n';
import { BRAND_NAME } from '../config/brand';
import chargeback from './chargeback/en';
import contactUs from './contactUs/en';
import customerDetails from './customerDetails/en';
import customer from './customers/en';
import dispatches from './dispatches/en';
import disputes from './disputes/en';
import errors from './errors/en';
import home from './home/en';
import merchantOnboarding from './merchantOnboarding/en';
import merchants from './merchants/en';
import months from './months/en';
import notAuthorized from './notAuthorized/en';
import notFound from './notFound/en';
import notificationDetails from './notificationDetails/en';
import notifications from './notifications/en';
import onboarding from './onboarding/en';
import orderDetails from './orderDetails/en';
import outstanding from './outstanding/en';
import payment from './payment/en';
import refundDetails from './refundDetails/en';
import refunds from './refunds/en';
import settings from './settings/en';
import settlementDetails from './settlementDetails/en';
import settlements from './settlements/en';
import subscription from './subscription/en';
import subscriptionHistory from './subscriptionHistory/en';
import transactions from './transactions/en';
import transactionsList from './transactionsList/en';
import validationModal from './validationModal/en';

export default {
  ...i18n.en,
  'login.title': `${BRAND_NAME} login`,
  'status.DISPATCHED': 'Dispatched',
  'status.WON': 'Won',
  'status.LOST': 'Lost',
  'status.DISPUTE': 'Dispute',
  'status.NOT_SHIPPED': 'Not dispatched',
  'status.PENDING_RENEWAL': 'Pending Renewal',
  'status.NOT_REFUNDED': 'Not refunded',
  'status.PENDING_APPROVAL': 'Pending approval',
  'status.UNDER_REVIEW': 'Under Review',
  'status.APPROVED': 'Approved',
  'status.DISBURSED': 'Disbursed',
  'status.RECEIVED': 'Received',
  'button.confirm': 'Confirm',
  'button.reject': 'Reject',
  'filed.empty': '-',
  ...errors,
  ...home,
  ...payment,
  ...notifications,
  ...notificationDetails,
  ...dispatches,
  ...settlements,
  ...outstanding,
  ...refunds,
  ...merchants,
  ...merchantOnboarding,
  ...subscriptionHistory,
  ...disputes,
  ...transactions,
  ...transactionsList,
  ...onboarding,
  ...contactUs,
  ...notAuthorized,
  ...notFound,
  ...months,
  ...settlementDetails,
  ...subscription,
  ...refundDetails,
  ...customerDetails,
  ...customer,
  ...validationModal,
  ...settings,
  ...orderDetails,
  ...chargeback,
};
